/**
 * 从trip对象查询数据
 */
import {
  isHotel,
  isStore
} from '../poi';
import {
  getPoiMap,
  getCityMap,
  getPoiList,
  getPoiListItem
} from './getStatic';
import qs from 'qs';


// 行程的分享选项
export function getShareOptions(trip) {
  let title = getTitle(trip);
  let content = `我的【${title}】已经规划好了，快来看看吧！`;
  let photo = trip.cover_pic;
  let path = window.location.href.split('?')[0];
  path = window.location.origin;
  let shareUrl = path + '/m/v2/?' + qs.stringify({
    m: 'trip/share',
    trip_id: trip.trip_id,
    from: 'share',
    code: (trip.share && trip.share.code),
    source_app: 'tantutravel',
    version: '1.1'
  });

  return {title, content, photo, shareUrl};
}


/**
 * 获取行程的名称
 * @param {*} trip
 * @param {*} useTripName 是否优先使用trip_name作为行程名字
 * trip_name 默认优先级最高
 * 没有再自己拼接 国家天数作为标题
 */
export function getTitle(trip, useTripName = true) {
  if(trip.trip_name && useTripName){
    return trip.trip_name;
  }

  let region_info_map = trip.region_info_maps;

  if (!region_info_map) {
    return trip.trip_name || '缺少title';
  }

  let start_region = region_info_map[trip.start_region];
  let end_region = region_info_map[trip.end_region];

  if (!start_region || !end_region) {
    return '数据不完整';
  }

  let _start = start_region.region_cn || start_region.cn_name;
  let _end = end_region.region_cn || end_region.cn_name;
  if (_start === _end) {
    return `${_start}${trip.trip_days}天行程`;
  } else {
    return `${_start}-${_end}${trip.trip_days}天行程`;
  }
}

// 是否进行中
export function isProcessing(trip) {
  let now = Date.now() / 1000;

  return trip.start_time < now && trip.end_time > now;
}

// 是否即将出发（两周内出发）
export function beProcess(trip) {
  let now = Date.now() / 1000;
  let twoWeek = 60 * 60 * 24 * 14;
  
  return trip.start_time > now && (trip.start_time - now) <= twoWeek;
}

// 是否已经结束
export function isFinish(trip) {
  if (!trip.start_time || !trip.end_time) {
    return false;
  }

  let now = Date.now() / 1000;
  return trip.end_time < now;
}

// 我的行程（途径城市）
export function getCityList(trip) {
  if (!trip.city_list) {
    return '';
  }
  return Object.keys(trip.city_list).map(key => {
    return trip.city_list[key].cn_name;
  }).join(' > ');
}

// 推荐行程（途径poi点）
export function getPoiData(poiList) {
  if (!poiList.length) {
    return '';
  }
  return poiList.map(item => {
    return item.cn;
  }).join(' > ');
}


/**
 * city部分
 */

// 是否存在城市
export function existCity(trip, city_id, day) {
  let result = false;
  let cities = day ? getCitiesByDay(trip, day) : getAllCities(trip);

  cities.forEach(function (city) {
    if (city.city === city_id) result = true;
  });

  return result;
}

export function getCityById(trip, city_id) {
  let cityMap = getCityMap(trip);

  return cityMap[city_id];
}

export function getCities(trip, day) {
  if (day) {
    return getCitiesByDay(trip, day);
  } else {
    return getAllCities(trip);
  }
}


/**
 * 所有城市
 * 是一个途径城市，有次序的
 */ 
function getAllCities(trip) {
  let poiList = getPoiList(trip);
  let cityMap = getCityMap(trip);
  let cityIds = [];
  poiList.forEach(function (item) {
    item.city_list.forEach(function (city) {
      let lastCityId = cityIds[cityIds.length-1];
      if(lastCityId !== city.city_id){
        cityIds.push(city.city_id);
      }
      // if (cityIds.indexOf(city.city_id) === -1) {
      //   cityIds.push(city.city_id);
      // }
    });
  });

  let result = [];
  cityIds.forEach(function (id) {
    let city = cityMap[id];
    if (city) result.push(city);
  });

  return result;
}

// 某天的所有城市
function getCitiesByDay(trip, day) {
  let cityMap = getCityMap(trip);
  let dayTrip = getPoiListItem(trip, day);
  let result = [];
  if(dayTrip && dayTrip.city_list && dayTrip.city_list.length){
    dayTrip.city_list.forEach(function (city) {
      let id = city.city_id;
      city = cityMap[id];
      if (city) result.push(city);
    });
  }

  return result;
}





/**
 * 获取全程线路的城市marker
 * 
 * @export
 * @param {any} trip 
 * @returns 
 */
export function getFullTripCityMarkers(trip){
  let cities = getCities(trip);
  return cities.map(function (city) {
    let days = [];
    for (let day = 1; day <= trip.trip_days; day++) {
      if (existCity(trip, city.city, day)) {
        days.push(day);
      }
    }
    return {
      type: 'imageTextMarker',
      latLng: [city.lat, city.lng],
      imageUrl: city.pic.small_s,
      title: city.cn_name,
      desc: `第${days.join(',')}天`,
      days: days,
      source: city
    };
  });
}

/**
 * dayTrip
 * 某天行程的城市列表和poi列表
 * 如果为空，则用前一天的最后一个填充
 */


/**
 * 获取某天的城市列表
 * @param {*} trip
 * @param {*} day
 */
export function getCitiesOfDayTrip(trip, day) {
  let result = getCities(trip, day);

  if (!result.length) {
    day--;
    let endCity = forceGetEndCityByDay(trip, day);
    if (endCity) result = [endCity];
  }

  return result;
}

// 获取某天的终点城市。如果没有，则递归上一天
function forceGetEndCityByDay(trip, day) {
  let cities = getCitiesByDay(trip, day);
  
  if (cities.length === 0) {
    if (day <= 1) {
      return null;
    } else {
      day--;
      return forceGetEndCityByDay(trip, day);
    }
  } else {
    return cities.pop();
  }
}


// 某天行程的所有pois（包含前一天的终点poi）
export function getPoisOfDayTrip(trip, day) {
  let result = getPois(trip, day);
  if (day > 1) {
    day--;
    let endPoi = forceGetEndPoiByDay(trip, day);
    if (endPoi) {
      // 上一天
      endPoi = {...endPoi, isPrev: true};
      result.unshift(endPoi);
    }
  }

  return result;
}


// 获取某天的终点poi（产品要求必须是酒店，如果不是，怎获取终点city代替）。
function forceGetEndPoiByDay(trip, day) {
  let pois = getPois(trip, day);
  let result = pois.pop();

  if (!result) {
    result = forceGetEndCityByDay(trip, day);
  }

  return result;
}



/**
 * poi部分
 */
export function existPoi(trip, poi_uid, day) {
  let pois = getPois(trip, day);
  let result = false;

  pois.forEach(function (poi) {
    if (poi.poi_uid === poi_uid) result = true;
  });

  return result;
}

// 通过poi_uid获取poi
export function getPoiByPoiuid(trip, poi_uid) {
  let poiMap = getPoiMap(trip);

  return poiMap[poi_uid];
}

/**
 * poi列表
 * @param {*} trip
 * @param {*} day 某天？如果缺少该参数，则返回所有poi
 */
export function getPois(trip, day) {
  if (day) {
    return getPoisByDay(trip, day);
  } else {
    return getAllPois(trip);
  }
}

// 全程所有poi
function getAllPois(trip) {
  let poiList = getPoiList(trip);
  let poiMap = getPoiMap(trip);
  let result = [];

  poiList.forEach(function (item) {
    item.pois.forEach(function (poi) {
      poi = poiMap[poi.poi_uid];
      poi && result.push(poi);
    });
  });

  return result;
}

// 全程某天所有poi
function getPoisByDay(trip, day) {
  let poiMap = getPoiMap(trip);
  let poi_list_item = getPoiListItem(trip, day);
  let pois = poi_list_item.pois;
  let result = [];

  pois.forEach(function (poi) {
    poi = poiMap[poi.poi_uid];
    poi && result.push(poi);
  });

  return result;
}




// 目前只在trip-edit页面用到。
// 注意：之后将删除改接口，用getPois或其他接口代替
export function getPoisByPoiUids(trip, poiUids) {
  let poiMap = getPoiMap(trip);
  let result = [];

  poiUids.forEach(function (poiUid) {
    if (poiMap[poiUid]) {
      result.push(poiMap[poiUid]);
    } else {
      console.warn(poiUid, 'missed in poiMap');
    }
  });

  return result;
}




/**
 * 获取每天poi顺序安排，用于智能优化
 * @param {*} trip
 */
export function getDaysArrange(trip) {

  let { poi_list, start_city } = trip,
    daysArrange = [],
    preDayPoiUid = 'C.' + start_city;

  poi_list.forEach((day, dayIndex) => {
    let pois = day.pois,
      poiLastIndex = pois.length - 1,
      startPoiUid = preDayPoiUid,
      dayPoiUids = [],
      endPoiUid = '';

    pois.forEach((poi, poiIndex) => {

      // 每天起始点：第一天拿取车点，没有的话取城市点
      if (poiIndex === 0 && dayIndex === 0 && isStore(poi)) {
        startPoiUid = poi.poi_uid;
        preDayPoiUid = poi.poi_uid;
        return;
      }

      // 每天结束点：酒店或还车点
      if (poiIndex === poiLastIndex && (isHotel(poi) || isStore(poi))) {
        endPoiUid = poi.poi_uid;
        preDayPoiUid = poi.poi_uid;
        return;
      }

      dayPoiUids.push(poi.poi_uid);
      preDayPoiUid = poi.poi_uid;
    });

    daysArrange.push({
      startPoiUid,
      dayPoiUids,
      endPoiUid,
      canOptimize: dayPoiUids.length > 1
    });
  });

  return daysArrange;
}



// WEBPACK FOOTER //
// ./src/helpers/trip/find.js